/**
 * Временные флаги публикации данных, которые должны относиться только к ИП Гастамировой.
 * Файлы при отключении остаются в хранилище, но ссылки и сведения не выводятся в интерфейсе.
 */
export const ANSARIT_PUBLICATION = {
    offerContract: true,
    license: true,
} as const
